import { render, staticRenderFns } from "./CreditBackView.vue?vue&type=template&id=b21e89b2&scoped=true&"
import script from "@/scripts/creditback/creditBackView.js?vue&type=script&lang=js&"
export * from "@/scripts/creditback/creditBackView.js?vue&type=script&lang=js&"
import style0 from "./CreditBackView.vue?vue&type=style&index=0&id=b21e89b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21e89b2",
  null
  
)

export default component.exports